// https://github.com/chakra-ui/chakra-ui/blob/main/packages/components/theme/src/foundations/shadows.ts

export const shadows = {
  button: 'rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px',
}
